<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Terms & Conditions</h2>
            <ul>
                <li>
                    <a routerLink="/">
                        Home
                    </a>
                </li>
                <li>
                    Terms & Conditions
                </li>
            </ul>
        </div>
    </div>
</div>

<section class="features-area ptb-110">
    <div class="container">
        <div class="overview-box">
            <div class="row" style="text-align: justify;">
                <h1>
                    Terms & Conditions
                </h1>
                <h2  class="mt-1" style="display: ruby;">Welcome to  <a href="https://vocbot.ai/"> Vocbot.Ai! </a></h2>

                <p class="mt-1">
                    These terms and conditions outline the rules and regulations for the use of VOCBOT.AI TECHNOLOGY PVT
                    LTD's Website, located at <a href="https://vocbot.ai/">https://vocbot.ai/</a>.
                </p>
                <p class="mt-1">
                    By accessing this website we assume you accept these terms and conditions. Do not continue to use
                    Vocbot.Ai if you do not agree to take all of the terms and conditions stated on this page.
                </p>
                <p class="mt-1">The following terminology applies to these Terms and Conditions, Privacy Statement and
                    Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on
                    this website and compliant to the Company's terms and conditions. "The Company", "Ourselves", "We",
                    "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and
                    ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to
                    undertake the process of our assistance to the Client in the most appropriate manner for the express
                    purpose of meeting the Client's needs in respect of provision of the Company's stated services, in
                    accordance with and subject to, prevailing law of in. Any use of the above terminology or other
                    words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable
                    and therefore as referring to same.</p>

                <h1 class="mt-3 mb-3">
                    Cookies
                </h1>

                <p class="mt-1">
                    We employ the use of cookies. By accessing Vocbot.Ai, you agreed to use cookies in agreement with
                    the VOCBOT.AI TECHNOLOGY PVT LTD's Privacy Policy.
                <p class="mt-1">
                    Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies
                    are used by our website to enable the functionality of certain areas to make it easier for people
                    visiting our website. Some of our affiliate/advertising partners may also use cookies.
                </p>
                <h1 class="mt-3 mb-3"> License</h1>
                <p class="mt-1">
                    Unless otherwise stated, VOCBOT.AI TECHNOLOGY PVT LTD and/or its licensors own the intellectual
                    property rights for all material on Vocbot.Ai. All intellectual property rights are reserved. You
                    may access this from Vocbot.Ai for your own personal use subjected to restrictions set in these
                    terms and conditions.
                </p>
                <div>
                    <p>You must not:</p>
                    <ul class="list">
                        <li>
                            <i class='bx bx-check'></i>
                            Republish material from Vocbot.Ai
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Sell, rent or sub-license material from Vocbot.Ai
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Reproduce, duplicate or copy material from Vocbot.Ai
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Redistribute content from Vocbot.Ai
                        </li>

                    </ul>

                </div>
                <!-- <p class="mt-1">This Agreement shall begin on the date hereof. Our Terms and Conditions were created
                    with the help of the Free Terms and Conditions Generator.</p> -->



                <p class="mt-1">Parts of this website offer an opportunity for users to post and exchange opinions and
                    information in certain areas of the website. VOCBOT.AI TECHNOLOGY PVT LTD does not filter, edit,
                    publish or review Comments prior to their presence on the website. Comments do not reflect the views
                    and opinions of VOCBOT.AI TECHNOLOGY PVT LTD,its agents and/or affiliates. Comments reflect the
                    views and opinions of the person who post their views and opinions. To the extent permitted by
                    applicable laws, VOCBOT.AI TECHNOLOGY PVT LTD shall not be liable for the Comments or for any
                    liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of
                    and/or appearance of the Comments on this website.</p>
                <p class="mt-1">
                    VOCBOT.AI TECHNOLOGY PVT LTD reserves the right to monitor all Comments and to remove any Comments
                    which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.
                </p>


                <div>
                    <p>You warrant and represent that:</p>
                    <ul class="list">
                        <li>
                            <i class='bx bx-check'></i>
                            You are entitled to post the Comments on our website and have all necessary licenses and
                            consents to do so;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            The Comments do not invade any intellectual property right, including without limitation
                            copyright, patent or trademark of any third party;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Reproduce, duplicate or copy material from Vocbot.Ai
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            The Comments will not be used to solicit or promote business or custom or present commercial
                            activities or unlawful activity.
                        </li>

                    </ul>

                </div>
                <p class="mt-1"> You hereby grant VOCBOT.AI TECHNOLOGY PVT LTD a non-exclusive license to use,
                    reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all
                    forms, formats or media.</p>

                <h1 class="mt-3 mb-3">
                    Hyperlinking to our Content
                </h1>

                <div>
                    <p>The following organizations may link to our Website without prior written approval:</p>
                    <ul class="list">
                        <li>
                            <i class='bx bx-check'></i>
                            Government agencies;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Search engines;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            News organizations;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            Online directory distributors may link to our Website in the same manner as they hyperlink
                            to the Websites of other listed businesses; and
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            System wide Accredited Businesses except soliciting non-profit organizations, charity
                            shopping malls, and charity fundraising groups which may not hyperlink to our Web site.
                        </li>

                    </ul>
                    <p class="mt-1">These organizations may link to our home page, to publications or to other Website
                        information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply
                        sponsorship, endorsement or approval of the linking party and its products and/or services; and
                        (c) fits within the context of the linking party's site.</p>

                </div>
                <div>
                    <p>We may consider and approve other link requests from the following types of organizations:</p>
                    <ul class="list">
                        <li>
                            <i class='bx bx-check'></i>
                            commonly-known consumer and/or business information sources;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            dot.com community sites;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            associations or other groups representing charities;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            online directory distributors;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            internet portals;
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            accounting, law and consulting firms; and
                        </li>
                        <li>
                            <i class='bx bx-check'></i>
                            educational institutions and trade associations.
                        </li>

                    </ul>

                </div>

                <p class="mt-1">We will approve link requests from these organizations if we decide that: (a) the link
                    would not make us look unfavorably to ourselves or to our accredited businesses; (b) the
                    organization does not have any negative records with us; (c) the benefit to us from the visibility
                    of the hyperlink compensates the absence of VOCBOT.AI TECHNOLOGY PVT LTD; and (d) the link is in the
                    context of general resource information.</p>
                <p class="mt-1">If you are one of the organizations listed in paragraph 2 above and are interested in
                    linking to our website, you must inform us by sending an e-mail to VOCBOT.AI TECHNOLOGY PVT LTD.
                    Please include your name, your organization name, contact information as well as the URL of your
                    site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our
                    site to which you would like to link. Wait 2-3 weeks for a response.</p>
                <p class="mt-1">If you are one of the organizations listed in paragraph 2 above and are interested in
                    linking to our website, you must inform us by sending an e-mail to VOCBOT.AI TECHNOLOGY PVT LTD.
                    Please include your name, your organization name, contact information as well as the URL of your
                    site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our
                    site to which you would like to link. Wait 2-3 weeks for a response.</p>

                    <div>
                        <p>Approved organizations may hyperlink to our Website as follows:</p>
                        <ul class="list">
                            <li>
                                <i class='bx bx-check'></i>
                                By use of our corporate name; or
                            </li>
                            <li>
                                <i class='bx bx-check'></i>
                                By use of the uniform resource locator being linked to; or
                            </li>
                            <li>
                                <i class='bx bx-check'></i>
                                By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site.
                            </li>
                            
    
                        </ul>
    
                    </div>

                    <p class="mt-1">No use of VOCBOT.AI TECHNOLOGY PVT LTD's logo or other artwork will be allowed for linking absent a trademark license agreement.</p>

                    <h1 class="mt-3 mb-3">
                        iFrames
                    </h1>
                    <p class="mt-1">Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.</p>
  
                    <h1 class="mt-3 mb-3">
                        Content Liability
                    </h1>
                  <p class="mt-1">We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.</p>
                
                  <h1 class="mt-3 mb-3">
                    Reservation of Rights
                </h1>
                <p class="mt-1" >We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it's linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.</p>
                <h1 class="mt-3 mb-3">
                    Removal of links from our website
                </h1>
                <p class="mt-1">If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.</p>

<p class="mt-1">We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.</p>
                     
<h1 class="mt-3 mb-3">
    Disclaimer
</h1>


<div>
    <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:</p>
    <ul class="list">
        <li>
            <i class='bx bx-check'></i>
            limit or exclude our or your liability for death or personal injury;
        </li>
        <li>
            <i class='bx bx-check'></i>
            limit or exclude our or your liability for fraud or fraudulent misrepresentation;
        </li>
        <li>
            <i class='bx bx-check'></i>
            limit any of our or your liabilities in any way that is not permitted under applicable law; or
        </li>
        <li>
            <i class='bx bx-check'></i>
            exclude any of our or your liabilities that may not be excluded under applicable law.
        </li>

    </ul>

</div>


<p class="mt-1">The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</p>
  <p class="mt-1">As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
                  <div style="line-height: 30px;">
                   

                    <h1 class="mt-3 mb-3">
                        Contact Us:
                    </h1>
                    <p>
                        If you have any questions about this Privacy Policy, You can contact us:
                    </p>
                    <p>
                        <strong>Email-id:</strong>
                        <a href="mailto: info@vocbot.ai" style="display: contents !important;color: blue;">
                            info@vocbot.ai
                        </a>
                    </p>
                    <p>
                        <strong>Phone Number:</strong>
                        <a href="tel:+91-9826323332" style="display: contents !important;">
                            +91-9826323332
                        </a>
                    </p>
                    <p>
                        <strong>Address:</strong>
                        43 Pratap Nagar, &nbsp;Manik Bagh Road, &nbsp;Near Gurunanak Dharmashala &nbsp;Indore (M.P.),
                        &nbsp;452001
                    </p>

                    <h3 class="mt-2" style="float: right;">
                        <strong>
                            Last updated:
                        </strong>
                        &nbsp;March 27, 2024
                    </h3>
                </div>
            </div>
        </div>
    </div>
</section>